module.exports = __webpack_public_path__ + "img/mobile-39.2e6dd32d.png";